/**
 * 指定されたログをJSON形式に変換し、指定されたURLにPOSTリクエストを送信します。
 *
 * @param {Object[]} log - 送信するログデータ
 * log[0]はページ(product ,cart ...)・・・strings
 * log[1]はアクション(view, add, remove ...)・・・strings
 * log[2]はログのオブジェクト名・・・strings
 * log[3]はログの内容・・・objects
 */
async function debugLogPost(log) {
    try {
        const logObj = {
            debug_page: log[0],
            debug_action: log[1],
            debug_obj: log[2],
            debug_log: log[3]
        };
        const logText = JSON.stringify(logObj);

        const response = await fetch('https://api.abistudio.com/post_debug_log/3', {  // ログ受け取りURL
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: logText
        });

        if (!response.ok) {
            // console.error(`HTTP error! status: ${response.status}`);
        } else {
            // 必要に応じてレスポンスを処理
            // console.log(await response.json());
        }
    } catch (error) {
        // console.error('ログの送信中にエラーが発生しました:', error);
    }
}
